import React from 'react';

import './style.scss';

export enum FundingStatus {
    // 通用状态
    Pending = 1, // 已接收
    Submitted, // 已提交到BR
    SubmitFail, // 提交BR失败
    Success, // 成功
    Fail, // 失败
    Rejected, // 已拒绝
    Submitting, // 提交中
    // 出金特有状态
    PrimaryAudit = 20, // 审核通过
    Cancelled, // 已取消
    Returned, // 已退回
    PrimaryAuditing // 审核中
}

const FundingStatusMap: Record<
    FundingStatus,
    {
        process: 'fail' | 'success' | 'pending';
        desc: string;
    }
> = {
    [FundingStatus.Pending]: {
        process: 'pending',
        desc: __('Pending')
    },
    [FundingStatus.Submitted]: {
        process: 'pending',
        desc: __('Submitted')
    },
    [FundingStatus.SubmitFail]: {
        process: 'fail',
        desc: __('Error:history-status')
    },
    [FundingStatus.Success]: {
        process: 'success',
        desc: __('Completed:history-status')
    },
    [FundingStatus.Fail]: {
        process: 'fail',
        desc: __('Failed')
    },
    [FundingStatus.Rejected]: {
        process: 'fail',
        desc: __('Rejected')
    },
    [FundingStatus.Submitting]: {
        process: 'pending',
        desc: __('Submitting')
    },
    [FundingStatus.PrimaryAudit]: {
        process: 'pending',
        desc: __('Audited')
    },
    [FundingStatus.Cancelled]: {
        process: 'pending',
        desc: __('Canceled')
    },
    [FundingStatus.Returned]: {
        process: 'pending',
        desc: __('Returned')
    },
    [FundingStatus.PrimaryAuditing]: {
        process: 'pending',
        desc: __('Auditing')
    }
};

interface StatusTagProps {
    status?: FundingStatus;
    // 支持自定义文案，如果传了 则默认展示custom信息
    custom?: {
        desc: string;
        process: 'fail' | 'success' | 'pending';
    };
}

const StatusTag: React.FC<StatusTagProps> = ({ status, custom }) => {
    if (custom) {
        return <div className={`funding-records-status-tag tag-${custom.process}`}>{custom.desc}</div>;
    } else if (status) {
        const { desc = status, process = 'pending' } = FundingStatusMap[status] || {};

        return <div className={`funding-records-status-tag tag-${process}`}>{desc}</div>;
    }

    return null;
};

export default StatusTag;
